import React from "react";
import withLayout from "layouts/Layout";

const About = () => {
  return <div>About Page</div>;
};

export default withLayout(About);
